import { gql } from "lib/apolloClient";

export const addUnsplashAnalyticsMutation = gql`
  mutation addUnsplashAnalytics($url: String!) {
    platform {
      addUnsplashAnalytics(url: $url)
    }
  }
`;
